import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "@/section/router";
import { TemplateListSection } from "../TemplateList";

export function CfrTemplatesPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wide">
            CFR
          </p>
          <h2 className="text-2xl font-bold">Templates</h2>
        </div>
        <Button onClick={() => navigate(RoutePath.CfrDocumentsTemplatesCreate)}>
          <Plus className="mr-2 h-4 w-4" />
          Create Template
        </Button>
      </div>

      <TemplateListSection />
    </div>
  );
}

